import { Toast } from "antd-mobile"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import {businessDeposit, } from '@/apis/crypto';
import { FormInstance } from "antd-mobile/es/components/form";

import {dictMap} from './data';
import { isEqual } from "lodash"
import { useGlobalVerify } from "@/logic/verify"
import { CryptoMerchantInfo, useCryptoMerchantInfoStore } from "@/stores/CryptoMerchatStore";
import { useCryptoPayments } from "@/stores/CryptoTradingStore";

export const amountNotEnough = (cryptoMerchantInfo: CryptoMerchantInfo, amount:number) =>  {
  return Number(amount) > Number(cryptoMerchantInfo.businessAssureBalance);
}

const valiedateData = (data: {amount: number, paymentType: string}, cryptoMerchantInfo: CryptoMerchantInfo) => {
  if(!data.amount){
    return ('请输入转出数量');
  }
  if(amountNotEnough(cryptoMerchantInfo,data.amount) ){
    return ('超出最大可用金额');
  }
}

const initFormValue = {
  mainNet: 'Tronscan(TRC20)',
  paymentType: [dictMap['paymentType'][0][0].value],
}

const orderType = "DepositTransferOut";

export const useOutLogic = () => {
  const formRef = useRef<FormInstance>();
  const [data, setData] = useState<any>({...initFormValue});
  const [verifySecurePassword] = useGlobalVerify();
  const navigate = useNavigate();

  const getCryptoMerchantInfo = useCryptoMerchantInfoStore((state) => state.getCryptoMerchantInfo);
  const cryptoMerchantInfo = useCryptoMerchantInfoStore((state) => state.cryptoMerchantInfo);

  const {merchantPayments,} = useCryptoPayments()

  const _dictMap = useMemo(() =>{
    const {list} = merchantPayments['8'];//8 商家 usdt地址
    const address =  (list?.length ? list : []).map((item:any) => ({
        value: item.usdtAddress,
        text: item.usdtAddress,
      }));
    return {...dictMap, usdtAddress:[address]}
  }, [merchantPayments]);

  const onFormRef = useCallback((form: FormInstance) =>{
    formRef.current = form;
    form.setFieldsValue(initFormValue);
    getCryptoMerchantInfo();
  },[])

  useEffect(() => {
    formRef.current?.setFieldsValue({
      current:cryptoMerchantInfo.businessAssureBalance ? parseFloat(cryptoMerchantInfo.businessAssureBalance).toFixed(2) : '0.00',
    });
  }, [cryptoMerchantInfo.businessAssureBalance])

   // 提交订单
  const submit = async ()=>{
    const data = formRef.current?.getFieldsValue();
    const valiedateMsg = valiedateData(data, cryptoMerchantInfo);
    if(valiedateMsg){
      return Toast.show(valiedateMsg)
    }
    // TODO: 验证资金密码
    const securePassword = await verifySecurePassword();
    if (!securePassword) return;
    
    const { ok, msg } = await businessDeposit({
      paymentType: data.paymentType[0],
      amount: parseFloat(data.amount).toFixed(2),
      passageType:orderType,
      receivingAddress: data.usdtAddress[0],
      securePassword: securePassword as string,
    });
    if (ok) {
      navigate(-1)
    } else {
      Toast.show(msg);
    }

  }

  const onSubmit = useCallback(() => {
      submit();
  }, [])



  const onValuesChange = (values:any, allValues: any) => {
    const changeKeys = Object.keys(values);
    if(changeKeys.includes('paymentType')){
      if(!isEqual(allValues.paymentType, data.paymentType)){
        allValues.amount = 0;
        formRef.current?.setFieldsValue({amount: 0,current: 0})
        setData(allValues);
      }
    }
    if(changeKeys.includes('amount')){
      const valiedateMsg = valiedateData(allValues, cryptoMerchantInfo);
      if(valiedateMsg){
        return Toast.show(valiedateMsg)
      }

    }
  }

  return {
    onFormRef,
    data:{...data},
    onSubmit,
    onValuesChange,
    dictMap: _dictMap
  }
}
